<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import '@/assets/iconfont/iconfont.css'
export default {
  name: 'App',
  components: {

  }
}
</script>

<style>
 *{
    padding: 0;
    margin: 0;
  }
  #app{
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width:100%;
    height: 100%;
    overflow: auto;
  }
  html,body{
    width: 100%;
    height: 100vh;
    overflow-y: hidden;
  }
</style>
